module.exports = __webpack_public_path__ + "img/data_cai.a84bb871.jpg";